import React, { PureComponent } from 'react';
import CommonUtils from 'utilities/common-utils';
import { timeZone } from 'interfaces/timezone-type';
import FilterItemMenu from './FilterItemMenu';
import { IFilter } from 'interfaces/filter-interfaces';
import { FilterType } from 'utilities/enum-utils';
import _ from 'lodash';
import { Button, Group, Menu, Text } from '@good/ui/core';
import { ChevronDown, ChevronUp } from '@good/icons';

export interface IActiveFilterItemProps {
  filter: IFilter;
  isOpen: boolean;
  setIsOpen: (filterType: FilterType, isOpen: boolean) => void;
  saveNewFilterValue: (filterType: FilterType, newFilterValue: any, selectionLabel: string) => void;
  removeFilter: (filterType: FilterType) => void;
  displayTimezone: timeZone;
  usePortal: boolean;
  canRemove?: boolean;
  dateFilterV2?: boolean;
}

interface IActiveFilterItemState {
  loading: boolean;
}

export class ActiveFilterItem extends PureComponent<IActiveFilterItemProps, IActiveFilterItemState> {
  override state = { loading: false, isOpen: false };

  override render() {
    const { filter, usePortal } = this.props;
    const isShowCustomTitle = [FilterType.BOOKING_BILLING, FilterType.BATCH_BILLING, FilterType.PAID_BILLING].includes(
      filter.filter,
    );

    return (
      <Menu
        shadow='md'
        position='bottom-start'
        opened={this.props.isOpen}
        withinPortal={usePortal}
        // onInteraction={(nextOpenState) => this.props.setIsOpen(filter.filter, nextOpenState)}
      >
        <Menu.Target>
          <Button
            variant={this.props.isOpen ? 'light' : 'light'}
            size='sm'
            rightSection={!this.props.isOpen ? <ChevronDown /> : <ChevronUp />}
            onClick={() => this.props.setIsOpen(filter.filter, !this.props.isOpen)}
          >
            <Group gap={6}>
              <Text fw={650} size='sm'>
                {isShowCustomTitle
                  ? CommonUtils.getFilterSettings(filter.filter).customTitle
                  : CommonUtils.getFilterSettings(filter.filter).title}
              </Text>
              <Text size='sm'>|</Text>
              <Text size='sm'>{filter.selectionLabel}</Text>
            </Group>
          </Button>
        </Menu.Target>
        <Menu.Dropdown p={0}>
          <FilterItemMenu
            filter={this.props.filter}
            saveNewFilterValue={this.props.saveNewFilterValue}
            removeFilter={this.props.removeFilter}
            canRemove={this.props.canRemove}
            displayTimezone={this.props.displayTimezone}
            dateFilterV2={this.props.dateFilterV2}
            onClose={() => this.props.setIsOpen(filter.filter, false)}
          />
        </Menu.Dropdown>
      </Menu>
    );
  }
}
